export function buildOverviewItemId({ year, make, model, trim }) {
  return `${year}-${make.value}-${model.value}${trim?.name ? `-${trim.name}` : ''}`;
}
